import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import '@atino/ui/tokens.css';
import { App } from './app/App';
import { RouteErrorBoundary } from './app/RouteErrorBoundary';
import './app/styles/clickup-theme.css';
// Bo giao dien theo tai khoan (clickup / atino_dark) — PHAI nap sau clickup-theme.css.
import './app/styles/ui-themes.css';
// Nen responsive (o nhap 16px tren dien thoai, ...) — nap cuoi de thang moi theme.
import './app/styles/responsive.css';
// Modal Nhanh.vn co bang: gian theo bang tren may tinh, khong cuon ngang.
import './app/styles/nhanhvn-modal.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Bao cao nang deu co snapshot phia may chu; khong can tu goi lai
      // moi lan chuyen tab.
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 60_000,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Khong tim thay phan tu #root trong index.html');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <RouteErrorBoundary>
          <Suspense fallback={<div className="app-loading" role="status">Đang tải…</div>}>
            <App />
          </Suspense>
        </RouteErrorBoundary>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
